/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Previous_PageInputs */

const en_common_previous_page = /** @type {(inputs: Common_Previous_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous page`)
};

const es_common_previous_page = /** @type {(inputs: Common_Previous_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página anterior`)
};

/**
* | output |
* | --- |
* | "Previous page" |
*
* @param {Common_Previous_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_previous_page = /** @type {((inputs?: Common_Previous_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Previous_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_previous_page(inputs)
	return en_common_previous_page(inputs)
});